import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Navbar from '../Navbar/Navbar';
import api from '../Axios/axios';
import { FaPlus, FaEdit, FaTrash, FaPrint } from 'react-icons/fa';
import './AccountPage.scss';
import logottc from '../../assets/ttcLogo.png';
// DÜZELTME: İki nokta üst üste (:) yerine (/) kullanıldı
import logostar from '../../assets/starcraneLogo.png';

export default function AccountPage() {
  const { companyId } = useParams();
  const [report, setReport] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [editing, setEditing] = useState(null);
  const [logoForPrint, setLogoForPrint] = useState('ttc'); // 'ttc' veya 'star'

  const [form, setForm] = useState({
    DeliveryDate: '',
    ChequeOrBondDate: '',
    ChequeOrBondNumber: '',
    PaymentType: '1',       // default: Çek
    Amount: '',
    InvoiceAmount: '',
    IsInvoiceIssued: false,
    InvoiceDate: '',
    InvoiceNumber: '',
    Note: '',
    Files: []
  });

  // Raporu çek
  useEffect(() => {
    api.get(`/Rental/Report/${companyId}`)
      .then(res => setReport(res.data.data))
      .catch(console.error);
  }, [companyId]);

  // --- YAZDIRMA FONKSİYONLARI ---
  const runPrintLogic = (isSummaryOnly) => {
    document.body.classList.add(`printing-logo-${logoForPrint}`);
    if (isSummaryOnly) {
      document.body.classList.add('printing-summary-only');
    }
    window.print();
    document.body.classList.remove('printing-summary-only');
    document.body.classList.remove('printing-logo-ttc');
    document.body.classList.remove('printing-logo-star');
  };

  const handlePrintSummary = () => {
    runPrintLogic(true);
  };

  const handlePrintFull = () => {
    runPrintLogic(false);
  };
  // --- BİTİŞ: YAZDIRMA FONKSİYONLARI ---

  const openModal = (payment = null) => {
    // ... (Mevcut kodunuz - değişiklik yok) ...
    if (payment) {
      setForm({
        DeliveryDate: payment.deliveryDate?.split('T')[0] || '',
        ChequeOrBondDate: payment.chequeOrBondDate?.split('T')[0] || '',
        ChequeOrBondNumber: payment.chequeOrBondNumber || '',
        PaymentType: String(payment.paymentType),
        Amount: payment.amount,
        InvoiceAmount: payment.invoiceAmount,
        IsInvoiceIssued: payment.isInvoiceIssued,
        InvoiceDate: payment.invoiceDate?.split('T')[0] || '',
        InvoiceNumber: payment.invoiceNumber,
        Note: payment.note,
        Files: []
      });
      setEditing(payment.id);
    } else {
      setForm({
        DeliveryDate: '',
        ChequeOrBondDate: '',
        ChequeOrBondNumber: '',
        PaymentType: '1',
        Amount: '',
        InvoiceAmount: '',
        IsInvoiceIssued: false,
        InvoiceDate: '',
        InvoiceNumber: '',
        Note: '',
        Files: []
      });
      setEditing(null);
    }
    setShowModal(true);
  };

  const formatDuration = (baseMonths, extraMonths, extraDays) => {
    // ... (Mevcut kodunuz - değişiklik yok) ...
    const m0 = baseMonths || 0;
    const m1 = extraMonths || 0;
    const carry = Math.floor((extraDays || 0) / 30);
    const days = (extraDays || 0) % 30;
    const totalMonths = m0 + m1 + carry;
    return `${totalMonths} ay${days > 0 ? ` ${days} gün` : ''}`;
  };

  const closeModal = () => setShowModal(false);

  const handleChange = e => {
    // ... (Mevcut kodunuz - değişiklik yok) ...
    const { name, value, type, checked } = e.target;
    setForm(f => ({
      ...f,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleFile = e => {
    // ... (Mevcut kodunuz - değişiklik yok) ...
    setForm(f => ({ ...f, Files: Array.from(e.target.files) }));
  };

  const submitPayment = async () => {
    // ... (Mevcut kodunuz - değişiklik yok) ...
    const fd = new FormData();
    if (editing) {
      fd.append('Id', editing);
    } else {
      fd.append('CompanyId', companyId);
    }
    fd.append('DeliveryDate', form.DeliveryDate);
    fd.append('ChequeOrBondDate', form.ChequeOrBondDate);
    fd.append('ChequeOrBondNumber', form.ChequeOrBondNumber);
    fd.append('PaymentType', form.PaymentType);
    fd.append('Amount', form.Amount);
    fd.append('InvoiceAmount', form.InvoiceAmount);
    fd.append('IsInvoiceIssued', form.IsInvoiceIssued);
    fd.append('InvoiceDate', form.InvoiceDate);
    fd.append('InvoiceNumber', form.InvoiceNumber);
    fd.append('Note', form.Note);
    form.Files.forEach((file, i) => fd.append(`Files[${i}]`, file));

    try {
      if (editing) {
        await api.put('/Payment', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
      } else {
        await api.post('/Payment', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
      }
      const r = await api.get(`/Rental/Report/${companyId}`);
      setReport(r.data.data);
      closeModal();
    } catch (err) {
      console.error('Ödeme kaydetme hatası:', err);
    }
  };

  const deletePayment = async (paymentId) => {
    // ... (Mevcut kodunuz - değişiklik yok) ...
    if (!window.confirm('Bu ödemeyi silmek istediğinize emin misiniz?')) return;
    try {
      await api.delete('/Payment', { data: { Id: paymentId } });
      const r = await api.get(`/Rental/Report/${companyId}`);
      setReport(r.data.data);
    } catch (err) {
      console.error('Ödeme silme hatası:', err);
    }
  };

  if (!report) return null;

  const {
    totalProgressPayment,
    totalNonConstructionPayment,
    remainingPayment,
    totalNonConstructionPaymentInvoiceAmount,
    rentals = [],
    payments = []
  } = report;

  const nonConstructionPayments = payments.filter(
    p => p.constructionPayment !== true
  );

  return (
    <div className="account-page">
      <Navbar />

      <header className="account-header">
        <div className="header-main">
          <img
            src={logottc}
            alt="TTC Logo"
            className="print-logo logo-ttc"
          />
          <img
            src={logostar}
            alt="Star Logo"
            className="print-logo logo-star"
          />
          <div className="header-title">
            <h1>{report.company}</h1>
            <p className="subtitle">Muhasebe ve Ödeme Raporu</p>
          </div>
        </div>

        <div className="print-controls">
          <div className="logo-selector">
            <button
              className={`btn-logo ${logoForPrint === 'ttc' ? 'active' : ''}`}
              onClick={() => setLogoForPrint('ttc')}
            >
              TTC
            </button>
            <button
              className={`btn-logo ${logoForPrint === 'star' ? 'active' : ''}`}
              onClick={() => setLogoForPrint('star')}
            >
              STAR
            </button>
          </div>
          <div className="report-buttons">
            <button className="btn" onClick={handlePrintSummary}>
              <FaPrint /> Özet Rapor
            </button>
            <button className="btn" onClick={handlePrintFull}>
              <FaPrint /> Tüm Rapor
            </button>
          </div>
        </div>
      </header>

      {/* Totaller */}
      <div className="totals">
        {/* ... (Kod değişikliği yok) ... */}
        <div className="total-card progress">
          <span className="label">Toplam Yatırımcı Hakedişi</span>
          <span className="value">
            {Number(totalProgressPayment || 0).toLocaleString()} TL
          </span>
        </div>
        <div className="total-card paid">
          <span className="label">Toplam Yapılan Ödeme</span>
          <span className="value">
            {Number(totalNonConstructionPayment || 0).toLocaleString()} TL
          </span>
        </div>
        <div className="total-card remaining">
          <span className="label">Kalan Yatırımcı Hakedişi</span>
          <span className="value">
            {Number((totalProgressPayment - totalNonConstructionPayment) || 0).toLocaleString()} TL
          </span>
        </div>
        <div className="total-card invoiced">
          <span className="label">Toplam Kesilen Fatura Tutarı</span>
          <span className="value">
            {Number(totalNonConstructionPaymentInvoiceAmount || 0).toLocaleString()} TL
          </span>
        </div>
        <div className="total-card tobebilled">
          <span className="label">Kesilmesi Gereken Fatura</span>
          <span className="value">
            {(Number(totalProgressPayment || 0)
              - Number(totalNonConstructionPaymentInvoiceAmount || 0)
            ).toLocaleString()} TL
          </span>
        </div>
      </div>

      {/* Kiralama Raporu */}
      <div className="table-container">
        {/* ... (Kod değişikliği yok) ... */}
        <h2>Kiralama Raporu</h2>
        <table className="rentals-table">
          <thead>
            <tr>
              <th>Seri No</th>
              <th>Kiracı Firma</th>
              <th>Aylık Kira</th>
              <th>Başlangıç</th>
              <th>Bitiş</th>
              <th>Süre</th>
              <th>Hizmet Bedeli %</th>
              <th>Toplam Hakediş</th>
              <th>Hizmet Bedeli</th>
              <th>Yatırımcı Hakediş</th>
            </tr>
          </thead>
          <tbody>
            {rentals.map((r, i) => (
              <tr key={i}>
                <td>{r.serialNo}</td>
                <td>{r.rentingCompany}</td>
                <td>{(r.rent ?? 0).toLocaleString()} TL</td>
                <td>{new Date(r.startDate).toLocaleDateString()}</td>
                <td>{new Date(r.endDate).toLocaleDateString()}</td>
                <td>
                  {formatDuration(
                    r.rentalPeriod,
                    r.extraPeriodMonth,
                    r.extraPeriod ?? r.extratPeriod
                  )}
                </td>
                <td>{(r.commissionRate ?? 0)}%</td>
                <td>{(r.inclueVAT ?? 0).toLocaleString()} TL</td>
                <td>{(r.progressPayment ?? 0).toLocaleString()} TL</td>
                <td>{(r.serviceFee ?? 0).toLocaleString()} TL</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Ödeme Hareketleri */}
      <div className="table-container payments">
        {/* ... (Kod değişikliği yok) ... */}
        <h2>Ödeme Hareketleri</h2>
        <button className="btn add-btn" onClick={() => openModal()}>
          <FaPlus /> Ödeme Ekle
        </button>
        <table className="payments-table">
          <thead>
            <tr>
              <th>Teslim Tarihi</th>
              <th>Çek/Senet Tarihi</th>
              <th>Çek/Senet No</th>
              <th>Tür</th>
              <th>Ödeme</th>
              <th>Fatura Tutarı</th>
              <th>Fatura Kesildi</th>
              <th>Fatura Tarihi</th>
              <th>Fatura No</th>
              <th>Not</th>
              <th>Dosyalar</th>
              <th>İşlemler</th>
            </tr>
          </thead>
          <tbody>
            {nonConstructionPayments.map(p => (
              <tr key={p.id}>
                <td>{new Date(p.deliveryDate).toLocaleDateString()}</td>
                <td>{new Date(p.chequeOrBondDate).toLocaleDateString()}</td>
                <td>{p.chequeOrBondNumber || '-'}</td>
                <td>
                  {p.paymentType === 'Cheque' ? 'Çek'
                    : p.paymentType === 'Bond' ? 'Senet'
                      : p.paymentType === 'Transfer' ? 'Havale'
                        : '-'}
                </td>
                <td>{Number(p.amount || 0).toLocaleString()} TL</td>
                <td>{Number(p.invoiceAmount || 0).toLocaleString()} TL</td>
                <td>{p.isInvoiceIssued ? 'Evet' : 'Hayır'}</td>
                <td>{p.invoiceDate ? new Date(p.invoiceDate).toLocaleDateString() : '-'}</td>
                <td>{p.invoiceNumber || '-'}</td>
                <td>{p.note || '-'}</td>
                <td>
                  {p.files?.map((f, idx) => (
                    <a key={idx} href={f.url} target="_blank" rel="noopener noreferrer">
                      Dosya{idx + 1}
                    </a>
                  ))}
                </td>
                <td className="actions">
                  <FaEdit className="icon edit" onClick={() => openModal(p)} />
                  <FaTrash className="icon del" onClick={() => deletePayment(p.id)} />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Modal */}
      {showModal && (
        <div className="modal-backdrop">
          {/* ... (Kod değişikliği yok) ... */}
          <div className="modal">
            <h3>{editing ? 'Ödeme Düzenle' : 'Yeni Ödeme'}</h3>
            <div className="modal-body">
              {/* ... (Kod değişikliği yok) ... */}
              <div className="field half">
                <label>Teslim Tarihi</label>
                <input
                  type="date"
                  name="DeliveryDate"
                  value={form.DeliveryDate}
                  onChange={handleChange}
                />
              </div>
              <div className="field half">
                <label>Çek/Senet Tarihi</label>
                <input
                  type="date"
                  name="ChequeOrBondDate"
                  value={form.ChequeOrBondDate}
                  onChange={handleChange}
                />
              </div>
              <div className="field half">
                <label>Çek/Senet No</label>
                <input
                  type="text"
                  name="ChequeOrBondNumber"
                  value={form.ChequeOrBondNumber}
                  onChange={handleChange}
                />
              </div>
              <div className="field half">
                <label>Tür</label>
                <select
                  name="PaymentType"
                  value={form.PaymentType}
                  onChange={handleChange}
                >
                  <option value="Cheque">Çek</option>
                  <option value="Bond">Senet</option>
                  <option value="Transfer">Havale</option>
                </select>
              </div>
              <div className="field half">
                <label>Tutar</label>
                <input
                  type="number"
                  name="Amount"
                  value={form.Amount}
                  onChange={handleChange}
                />
              </div>
              <div className="field half">
                <label>Fatura Tutarı</label>
                <input
                  type="number"
                  name="InvoiceAmount"
                  value={form.InvoiceAmount}
                  onChange={handleChange}
                />
              </div>
              <div className="field half">
                <label>Fatura Kesildi</label>
                <input
                  type="checkbox"
                  name="IsInvoiceIssued"
                  checked={form.IsInvoiceIssued}
                  onChange={handleChange}
                />
              </div>
              <div className="field half">
                <label>Fatura Tarihi</label>
                <input
                  type="date"
                  name="InvoiceDate"
                  value={form.InvoiceDate}
                  onChange={handleChange}
                />
              </div>
              <div className="field half">
                <label>Fatura No</label>
                <input
                  type="text"
                  name="InvoiceNumber"
                  value={form.InvoiceNumber}
                  onChange={handleChange}
                />
              </div>
              <div className="field half">
                <label>Not</label>
                <input
                  type="text"
                  name="Note"
                  value={form.Note}
                  onChange={handleChange}
                />
              </div>
              <div className="field full-width">
                <label>Dosya Ekle</label>
                <input type="file" multiple onChange={handleFile} />
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn" onClick={submitPayment}>
                Kaydet
              </button>
              <button className="btn cancel" onClick={closeModal}>
                İptal
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}